<template>
  <el-dialog
    :close-on-click-modal="false"
    title="校准时效"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="440px"
  >
    <section v-loading="getDetailLoading">
      <el-tabs :stretch="true" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.label"
          :name="item.name"
          v-for="(item, index) in timeForm"
          :key="index"
        >
          <CalibrationTimeForm
            :ref="item.formName"
            :trackType="item.trackType"
            :orderId="originData.orderId"
          />
        </el-tab-pane>
      </el-tabs>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
        >确 定</el-button
      >
    </section>
  </el-dialog>
</template>

<script>
import {
  orderCalibrationTime,
  getOrderSchedulerByOrderId,
} from 'api/operate';
import {
  getFileUrl,
} from 'api';
import CalibrationTimeForm from './calibrationTimeForm';
export default {
  components: {
    CalibrationTimeForm,
  },
  data () {
    return {
      activeName: '1',
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      originData: {},
      originFormData: [],
      timeForm: [
        { label: '发车时间', name: '1', trackType: 1, formName: 'ktTimeForm' },
        { label: '离台时间', name: '2', trackType: 2, formName: 'ltTimeForm' },
        { label: '到达时间', name: '3', trackType: 3, formName: 'ddTimeForm' },
        { label: '离场时间', name: '4', trackType: 4, formName: 'lcTimeForm' },
      ],
    };
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab, event);
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {

      this.dialogFormVisible = true; // 打开弹窗
      this.activeName = '1';
      this.resetForm();
      this.originData = item;
      this.getVerifyInfo(item);
    },

    resetForm () {
      this.$nextTick(() => {
        for (let item of this.timeForm) {
          if (this.$refs[item.formName]) {
            this.$refs[item.formName][0].resetFormVal();
          }
        }
      });
    },

    async getFileUrlByFileId (data) {
      let flowIds = [];
      const aImgName = [
        { flowId: 'verifyDependFileId', url: 'verifyDependFileUrl' },
        { flowId: 'verifyStartFileId', url: 'verifyStartFileUrl' },
        { flowId: 'verifyArriveFileId', url: 'verifyArriveFileUrl' },
        { flowId: 'verifyDepartureFileId', url: 'verifyDepartureFileUrl' },
      ];

      for (let imgItem of aImgName) {
        if (data[imgItem.flowId]) {
          flowIds.push(data[imgItem.flowId]);
        }
      }

      const imgRes = await getFileUrl({
        flowIds: flowIds.join(),
      });

      for (let imgItem of aImgName) {
        imgRes.items.forEach((item) => {
          if (`${item.flowId}` === `${data[imgItem.flowId]}`) {
            data[imgItem.url] = item.fullPath;
          }
        });
      }
    },

    async getVerifyInfo (item) {
      this.originFormData = [];
      const res = await getOrderSchedulerByOrderId({
        orderId: item.orderId,
      });
      if (!res.failed) {
        const data = res.orderScheduler;
        await this.getFileUrlByFileId(data);
        this.originFormData = [
          {
            formName: 'ktTimeForm',
            fileId: data.verifyDependFileId || 0,
            fileUrl: data.verifyDependFileUrl || '',
            verifyDate: data.verifyDependDate || '',
          },
          {
            formName: 'ltTimeForm',
            fileId: data.verifyStartFileId || 0,
            fileUrl: data.verifyStartFileUrl || '',
            verifyDate: data.verifyStartDate || '',
          },
          {
            formName: 'ddTimeForm',
            fileId: data.verifyArriveFileId || 0,
            fileUrl: data.verifyArriveFileUrl || '',
            verifyDate: data.verifyArriveDate || '',
          },
          {
            formName: 'lcTimeForm',
            fileId: data.verifyDepartureFileId || 0,
            fileUrl: data.verifyDepartureFileUrl || '',
            verifyDate: data.verifyDepartureDate || '',
          },
        ];
        for (let itemOrigin of this.originFormData) {
          const form = this.$refs[itemOrigin.formName][0];
          form.setFormVal(itemOrigin);
        }
      }
    },

    // 验证表单是否改变
    checkFormChange (newForm, oldForm) {
      let isChange = false;
      if (newForm.verifyDate !== oldForm.verifyDate) {
        isChange = true;
      }
      if (newForm.fileId !== oldForm.fileId) {
        isChange = true;
      }
      return isChange;
    },

    async customFormPost () {
      // this.$refs.customForm.sub();

      const currentFormName = this.timeForm[Number(this.activeName) - 1].formName;
      const currentForm = this.$refs[currentFormName][0].getFormVal();

      // 校验当前显示的表单
      if (!currentForm.verifyDate) {
        this.$message({
          type: 'warning',
          message: '请选择校准时间',
        });
        return;
      }

      if (!currentForm.fileId) {
        this.$message({
          type: 'warning',
          message: '请选择附件',
        });
        return;
      }

      this.subLoading = true;
      // 是否所有请求都成功
      let isAllPostSuccess = true;
      // 是否所有的表单都没有改变
      let isAllNoChange = true;

      // 检测每个表单的数据是否有变动，有变动的才提交
      for (let item of this.timeForm) {
        for (let itemOrigin of this.originFormData) {
          if (item.formName === itemOrigin.formName) {
            // 对比原始数据和当前提交的数据
            const newForm = this.$refs[item.formName][0].getFormVal();
            const oldForm = itemOrigin;
            if (this.checkFormChange(newForm, oldForm)) {
              isAllNoChange = false;
              // 验证表单是否改变，只有改变了的才发送请求
              const res = await orderCalibrationTime(newForm);
              if (res.failed) {
                isAllPostSuccess = false;
              }
            }
          }
        }
      }

      this.subLoading = false;
      if (isAllNoChange) {
        // 所有表单没有改变，不需要请求
        this.dialogFormVisible = false;
      } else {
        // 其中有表单有改变，需要发送请求
        if (isAllPostSuccess) {
          // 要所有请求都成功才关闭弹窗
          this.dialogFormVisible = false;
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.$emit('sub');
        }
      }
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await orderCalibrationTime({
        orderId: this.originData.orderId,
        trackType: form.trackType,
        verifyDate: `${this.formatDate(form.verifyDate, 1)}`,
        fileId: form.file[0].id,
        fileUrl: form.file[0].url,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
